import { TRADE_DIRECTION_SELL } from 'src/util/constants';

/**
 * Mobile breakpoint in pixels (Bootstrap md breakpoint).
 * Viewports below this width are considered mobile.
 * Default Bootsrap md breakpoint is 768px.
 * https://getbootstrap.com/docs/5.0/layout/breakpoints/
 */
export const MOBILE_BREAKPOINT = 768;

/**
 * Determines the tooltip placement based on trade direction and viewport size.
 * @param {string} tradeDirection - Trade direction (TRADE_DIRECTION_BUY or TRADE_DIRECTION_SELL)
 * @param {boolean} isMobile - Whether the viewport is mobile-sized
 * @returns {string} - Tooltip placement ('top', 'left', or 'right')
 * @example
 * // Desktop - Selling column (right side)
 * getTooltipPlacement(TRADE_DIRECTION_SELL, false); // Returns 'left'
 * @example
 * // Desktop - Buying column (left side)
 * getTooltipPlacement(TRADE_DIRECTION_BUY, false); // Returns 'right'
 * @example
 * // Mobile - Single column layout
 * getTooltipPlacement(TRADE_DIRECTION_BUY, true); // Returns 'top'
 */
export const getTooltipPlacement = (tradeDirection, isMobile) => {
  if (isMobile) {
    return 'top';
  }
  return tradeDirection === TRADE_DIRECTION_SELL ? 'left' : 'right';
};

/**
 * Creates a unique CardBody ID for tooltip targeting.
 * @param {string} ruleId - Unique identifier for the trade rule
 * @returns {string} - Unique CardBody ID in format 'card-body-{ruleId}'
 * @example
 * createCardBodyId('rule-123'); // Returns 'card-body-rule-123'
 */
export const createCardBodyId = (ruleId) => `card-body-${ruleId}`;
